import React from 'react';
import { ArrowDownTrayIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline';
import { QRCodeSVG } from 'qrcode.react';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../utils/downloadLinks';

function AppDownloadSection({ smartLinkUrl, variant = 'default' }) {
  return (
    <section
      className={`app-download-section app-download-section--${variant}`}
      aria-label="Download our app"
    >
      <div className="app-download-copy">
        <p className="app-download-eyebrow">Download our app</p>
        <h2 className="app-download-title">Take EMS with you</h2>
        <p className="app-download-description">
          Install the mobile app for faster attendance actions, approvals, and updates.
        </p>
      </div>

      <div className="app-download-store-links">
        <a
          className="store-button store-button-apple"
          href={APP_STORE_URL}
          target="_blank"
          rel="noreferrer"
        >
          <DevicePhoneMobileIcon className="h-5 w-5" />
          <span>Download on the App Store</span>
        </a>

        <a
          className="store-button store-button-google"
          href={GOOGLE_PLAY_URL}
          target="_blank"
          rel="noreferrer"
        >
          <ArrowDownTrayIcon className="h-5 w-5" />
          <span>Get it on Google Play</span>
        </a>
      </div>

      <div className="app-download-qr-card">
        <p className="app-download-qr-label">Scan to download the app</p>

        <div className="app-download-qr-frame">
          <QRCodeSVG value={smartLinkUrl} size={172} includeMargin />
        </div>

        <a
          className="app-download-fallback-link"
          href={smartLinkUrl}
          target="_blank"
          rel="noreferrer"
        >
          Having trouble scanning? Tap here to download.
        </a>
      </div>
    </section>
  );
}

export default AppDownloadSection;
